import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { IntegrationType } from '../../types/integration-type';
import { O365AuditWebView } from '../../sensors/o365Audit/view/O365AuditWebView';
import { O365MailWebView } from '../../sensors/o365Mail/view/O365MailWebView';
import { INTEGRATION_VIEW_BY_TYPE_MAP } from '../../types/integration-data';

export class IntegrationRequirementsWebView extends BaseWebComponentView {
  public dom: {
    $title: HTMLElement;
    $checklistArea: HTMLElement;
  };

  getDomElements() {
    this.dom = {
      $title: this.shadow.querySelector('#requirements-title'),
      $checklistArea: this.shadow.querySelector('#integration_requirements-checklist'),
    };

    this.getTranslations();
  }

  buildView() {
    this.buildSuccessView();
  }

  buildSuccessView(): void {}

  public addIntegrationSpecificRequirements(integrationType: IntegrationType) {
    if (!this.isConnected) {
      return;
    }
    if (integrationType === IntegrationType.O365) {
      this.dom.$checklistArea.innerHTML =
        '<b>' +
        this.dependencies.translateFn(
          'Before you integrate the Office 365 sensor platform with GravityZone, make sure the following requirements are met:'
        ) +
        '</b><br><br>' +
        O365MailWebView.getRequirements(this.dependencies) +
        O365AuditWebView.getRequirements(this.dependencies);
      return;
    }
    const sensorView = INTEGRATION_VIEW_BY_TYPE_MAP[integrationType];
    if (sensorView) {
      this.dom.$checklistArea.innerHTML = sensorView.getRequirements(this.dependencies);
    }
  }
}
